let host = "https://twllzz1ao0.execute-api.ap-southeast-1.amazonaws.com";

if (
    window.location.host.indexOf("localhost") >= 0 ||
    window.location.host.indexOf("127.0.0.1") >= 0
) {
    host = "https://twllzz1ao0.execute-api.ap-southeast-1.amazonaws.com";
} else if (
    window.location.host.indexOf("jindamarket.com") >= 0 ||
    window.location.host.indexOf("jinda.business") >= 0
) {
    host = "https://epx7wx2ggf.execute-api.ap-southeast-1.amazonaws.com";
}

export const base_url: string = host;